import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { query, submitSearchFacet, searchFacetChange } from '../Actions/FacetedSearch.action';
import FacetedSearchConfigurator from '../Components/FacetedSearchConfigurator';

class ColorFilterContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const colorFilterGroup = this.props.facetFilters.filter(x => x.id === "color");
        return !colorFilterGroup ? null :
            <Fragment>
                <FacetedSearchConfigurator
                    facetFilters={colorFilterGroup}
                    searchFacetChange={this.props.searchFacetChange}
                    cssClass={'hide-for-large'}
                />
            </Fragment>
            ;
    }
}

const mapStateToProps = ({ facetedSearch: { facetFilters } }) => {
    return {
        facetFilters,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        query: (q, withHtmlResult) => dispatch(query(q, withHtmlResult)),
        onSubmit: (allFilters) => dispatch(submitSearchFacet(allFilters)),
        searchFacetChange: (group, item) => dispatch(searchFacetChange(group, item)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ColorFilterContainer);